import { render, staticRenderFns } from "./CardConvenio.vue?vue&type=template&id=6f3a8368&"
import script from "./CardConvenio.vue?vue&type=script&lang=js&"
export * from "./CardConvenio.vue?vue&type=script&lang=js&"
import style0 from "./CardConvenio.vue?vue&type=style&index=0&id=6f3a8368&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports